module.exports = __webpack_public_path__ + "static/media/model-name.ac4da281.svg";